import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Shield, Award, Lock, UserCheck } from 'lucide-react';

const Trust = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const trustPoints = [
    {
      icon: Shield,
      title: '100% Originais',
      description: 'Todas as peças são rigorosamente autenticadas'
    },
    {
      icon: Award,
      title: 'Procedência Verificada',
      description: 'Histórico completo de cada relógio'
    },
    {
      icon: Lock,
      title: 'Transações Seguras',
      description: 'Máxima segurança em todas as negociações'
    },
    {
      icon: UserCheck,
      title: 'Atendimento Exclusivo',
      description: 'Consultoria personalizada para cada cliente'
    }
  ];

  return (
    <section
      ref={ref}
      className="py-24 md:py-32 px-6 md:px-12 bg-[#121212] relative overflow-hidden"
      data-testid="trust-section"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://images.pexels.com/photos/325872/pexels-photo-325872.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Watch mechanism"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.8 }}
        >
          <div className="uppercase text-[#C9A646] font-sans text-xs md:text-sm tracking-[0.3em] mb-6">
            Garantia de Excelência
          </div>
          <h2 className="font-serif text-3xl md:text-5xl text-white tracking-tight mb-6">
            Autenticidade Garantida
          </h2>
          <p className="font-sans text-base md:text-lg text-[#A3A3A3] max-w-3xl mx-auto">
            Cada peça é rigorosamente inspecionada. Trabalhamos apenas com relógios originais e oferecemos procedência verificada. Sua confiança é o nosso maior patrimônio.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {trustPoints.map((point, index) => {
            const Icon = point.icon;
            return (
              <motion.div
                key={index}
                className="text-center"
                initial={{ opacity: 0, y: 50 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
                transition={{ duration: 0.8, delay: index * 0.15 }}
                data-testid={`trust-point-${index}`}
              >
                <div className="inline-flex items-center justify-center w-16 h-16 border-2 border-[#C9A646] mb-6">
                  <Icon size={32} className="text-[#C9A646]" />
                </div>
                <h3 className="font-serif text-xl text-white mb-3">{point.title}</h3>
                <p className="font-sans text-sm text-[#A3A3A3] leading-relaxed">
                  {point.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Trust;
